import React from "react";

function Header() {
  return (
    <header>
      <h1>Note App</h1>
    </header>
  );
}

export default Header;